var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Facebook"),React.createElement("g",{"data-name":"Layer 2","key":2},React.createElement("g",{"data-name":"Layer 1"},React.createElement("path",{"d":"M7.5,5.42v3h4.2l-.3,3.8H7.5v13.2H2.6V12.22H0V8.42H2.6V5.82c0-1.1,0-2.9.8-3.9A4.77,4.77,0,0,1,7.5,0a15.66,15.66,0,0,1,4.7.5l-.7,3.9a9.34,9.34,0,0,0-2.1-.3C8.4,4,7.5,4.42,7.5,5.42Z"})))]);
}

SocialFacebook.defaultProps = {"role":"presentation","viewBox":"0 0 12.2 25.42"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
